var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Linkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.05,1.15H40.95C18.95,1.15,1.15,18.95,1.15,40.95v358.1c0,22,17.8,39.8,39.8,39.8h358.1c22,0,39.8-17.8,39.8-39.8V40.95c0-22-17.8-39.8-39.8-39.8ZM139.55,359.25h-58.7v-188.8h58.7v188.8ZM109.65,143.45c-18.9,0-34.2-15.3-34.2-34.2s15.3-34.2,34.2-34.2,34.2,15.3,34.2,34.2-15.4,34.2-34.2,34.2ZM359.35,359.25h-58.6v-91.8c0-21.9-.4-50.1-30.5-50.1s-35.2,23.9-35.2,48.5v93.4h-58.7v-188.8h56.3v25.8h.8c7.8-14.8,27-30.5,55.5-30.5,59.4,0,70.4,39.1,70.4,90,0,0,0,103.5,0,103.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Linkedin);
export default __webpack_public_path__ + "static/media/icons8-linkedin.881be7b7131ed0c7cafeca2c6e72d568.svg";
export { ForwardRef as ReactComponent };